var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResumeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 280,
    viewBox: "0 0 280 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 108,
    fill: "url(#paint0_linear_1185_17024)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 140,
    r: 91,
    fill: "url(#paint1_linear_1185_17024)",
    stroke: "black",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.737 89.7463H175.059V167.682L153.725 189.015H104.23V195.201C104.23 197.111 105.778 198.659 107.687 198.659H181.737C183.646 198.659 185.194 197.111 185.194 195.201C185.194 191.751 185.194 95.0401 185.194 93.2037C185.194 91.2943 183.646 89.7463 181.737 89.7463Z",
    fill: "url(#paint2_linear_1185_17024)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.77 167.682V84.2717C175.77 82.3621 174.223 80.8138 172.313 80.8138H98.2637C96.354 80.8138 94.806 82.3618 94.806 84.2717V186.269C94.806 188.178 96.3536 189.726 98.2637 189.726H153.725L175.77 167.682Z",
    fill: "url(#paint3_linear_1185_17024)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.889 124.066C134.889 125.976 133.341 127.524 131.431 127.524H108.669C106.759 127.524 105.212 125.976 105.212 124.066V94.3893C105.212 92.4801 106.759 90.9316 108.669 90.9316H131.431C133.341 90.9316 134.889 92.4799 134.889 94.3893V124.066Z",
    fill: "url(#paint4_linear_1185_17024)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.525 116.095H114.576C112.666 116.095 111.118 117.643 111.118 119.553V127.524H128.982V119.553C128.982 117.643 127.434 116.095 125.525 116.095Z",
    fill: "#88DCE5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.689 116.095H114.576C112.666 116.095 111.118 117.643 111.118 119.553V127.524H117.232V119.553C117.232 117.643 118.779 116.095 120.689 116.095Z",
    fill: "#74C4C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.05 110.813C123.243 110.813 125.832 108.224 125.832 105.03C125.832 101.837 123.243 99.2479 120.05 99.2479C116.856 99.2479 114.267 101.837 114.267 105.03C114.267 108.224 116.856 110.813 120.05 110.813Z",
    fill: "#F4CF9D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120.881 99.307C117.358 98.8022 114.268 101.534 114.268 105.03C114.268 108.223 116.857 110.812 120.05 110.812C121.621 110.812 123.046 110.185 124.088 109.167C119.351 108.486 117.463 102.643 120.881 99.307Z",
    fill: "#F7C781"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M175.77 167.682H157.183C155.273 167.682 153.725 169.23 153.725 171.139V189.727L175.77 167.682Z",
    fill: "url(#paint5_linear_1185_17024)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M131.426 129.296C134.315 129.296 136.665 126.946 136.665 124.057V105.083C136.665 104.1 135.869 103.303 134.886 103.303C133.903 103.303 133.107 104.1 133.107 105.083V124.057C133.107 124.984 132.353 125.737 131.427 125.737H130.756V119.541C130.756 116.652 128.405 114.302 125.517 114.302H114.561C111.672 114.302 109.322 116.652 109.322 119.541V125.737H108.651C107.725 125.737 106.971 124.984 106.971 124.057V94.3627C106.971 93.4365 107.725 92.6827 108.651 92.6827H131.427C132.353 92.6827 133.107 93.4365 133.107 94.3627V98.9141C133.107 99.897 133.903 100.693 134.886 100.693C135.869 100.693 136.666 99.897 136.666 98.9141V94.3627C136.666 91.4737 134.315 89.1237 131.427 89.1237H108.651C105.762 89.1237 103.412 91.4739 103.412 94.3627V124.057C103.412 126.946 105.762 129.296 108.651 129.296H131.426ZM112.881 125.737V119.541C112.881 118.614 113.635 117.861 114.561 117.861H125.517C126.443 117.861 127.196 118.614 127.196 119.541V125.737H112.881Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M112.473 105.009C112.473 109.181 115.867 112.575 120.039 112.575C124.21 112.575 127.604 109.181 127.604 105.009C127.604 100.838 124.21 97.4437 120.039 97.4437C115.867 97.4437 112.473 100.838 112.473 105.009ZM124.045 105.009C124.045 107.219 122.248 109.016 120.038 109.016C117.829 109.016 116.032 107.219 116.032 105.009C116.032 102.8 117.829 101.003 120.038 101.003C122.248 101.003 124.045 102.8 124.045 105.009Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M114.152 137.252C114.152 138.235 114.949 139.031 115.932 139.031H165.395C166.378 139.031 167.174 138.235 167.174 137.252C167.174 136.269 166.378 135.473 165.395 135.473H115.932C114.949 135.472 114.152 136.269 114.152 137.252Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M165.395 146.034H115.932C114.949 146.034 114.152 146.83 114.152 147.813C114.152 148.796 114.949 149.592 115.932 149.592H165.395C166.378 149.592 167.174 148.796 167.174 147.813C167.174 146.83 166.378 146.034 165.395 146.034Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.395 160.154C166.378 160.154 167.174 159.357 167.174 158.374C167.174 157.392 166.378 156.595 165.395 156.595H115.932C114.949 156.595 114.152 157.392 114.152 158.374C114.152 159.357 114.949 160.154 115.932 160.154H165.395Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M109.089 135.472H107.36C106.377 135.472 105.58 136.269 105.58 137.252C105.58 138.235 106.377 139.031 107.36 139.031H109.089C110.072 139.031 110.869 138.235 110.869 137.252C110.869 136.269 110.072 135.472 109.089 135.472Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.089 146.034H107.36C106.377 146.034 105.58 146.83 105.58 147.813C105.58 148.796 106.377 149.592 107.36 149.592H109.089C110.072 149.592 110.869 148.796 110.869 147.813C110.869 146.83 110.072 146.034 109.089 146.034Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.089 156.595H107.36C106.377 156.595 105.58 157.391 105.58 158.374C105.58 159.357 106.377 160.154 107.36 160.154H109.089C110.072 160.154 110.869 159.357 110.869 158.374C110.869 157.391 110.072 156.595 109.089 156.595Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M185.221 137.233C186.204 137.233 187 136.436 187 135.453V93.1765C187 90.2875 184.65 87.9375 181.761 87.9375H177.571V84.2392C177.571 81.3504 175.22 79 172.332 79H98.2392C95.3502 79 93 81.3504 93 84.2392V186.296C93 189.185 95.3502 191.535 98.239 191.535H102.43V195.233C102.43 198.122 104.78 200.472 107.669 200.472H181.761C184.65 200.472 187 198.122 187 195.233V141.622C187 140.639 186.204 139.843 185.221 139.843C184.238 139.843 183.441 140.639 183.441 141.622V195.234C183.441 196.16 182.687 196.913 181.761 196.913H107.669C106.743 196.913 105.989 196.16 105.989 195.234V191.535C156.121 191.535 154.02 191.649 154.634 191.288C154.798 191.192 154.903 191.103 154.991 191.014C178.289 167.717 177.094 168.933 177.239 168.729C177.442 168.445 177.555 168.119 177.568 167.758C177.569 167.738 177.571 167.718 177.571 167.698V91.4962H181.761C182.687 91.4962 183.441 92.25 183.441 93.1762V135.453C183.441 136.436 184.238 137.233 185.221 137.233ZM98.2392 187.976C97.313 187.976 96.5592 187.223 96.5592 186.297V84.2392C96.5592 83.3127 97.313 82.559 98.2392 82.559H172.332C173.258 82.559 174.012 83.3127 174.012 84.2392V165.918H157.193C154.304 165.918 151.954 168.269 151.954 171.157V187.976C149.76 187.976 100.56 187.976 98.2392 187.976ZM155.512 185.46V171.157C155.512 170.231 156.266 169.477 157.192 169.477H171.495C169.801 171.172 157.206 183.766 155.512 185.46Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1185_17024",
    x1: 222.354,
    y1: 140,
    x2: 32,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BFF0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82B4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1185_17024",
    x1: 210.916,
    y1: 140,
    x2: 47,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1185_17024",
    x1: 175.581,
    y1: 144.202,
    x2: 104.23,
    y2: 144.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9FE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1185_17024",
    x1: 166.157,
    y1: 135.27,
    x2: 94.806,
    y2: 135.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9FE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1185_17024",
    x1: 131.365,
    y1: 109.228,
    x2: 105.212,
    y2: 109.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBA6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A981FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1185_17024",
    x1: 173.153,
    y1: 178.704,
    x2: 153.725,
    y2: 178.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9FE81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0F0FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResumeIcon);
export default __webpack_public_path__ + "static/media/resume_icon.33a261d98459af333750f083ea0e212e.svg";
export { ForwardRef as ReactComponent };